export default {"src":"/_next/static/media/feminine.76c9d715.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};